<template>
  <div class="template-wrapper">
    <h2 class="page-title">{{ $t('orderRecords') }}</h2>
    <el-divider></el-divider>
    <template v-if="exportcsv === '1'">
        <!--
      <export-excel :data="tableDataExcel" :fields="tableDataExcelFields" :name="$t('orderRecords') + '.xls'"
        class="el-button el-button--default">
        {{ $t('exportOrderRecords') }}
      </export-excel>-->
      <el-button @click="exporttocsv($t('orderRecords'))">{{ $t("exportOrderRecords") }}</el-button>
    </template>

    <template v-if="order_read === '1'">
      <br />
      <br />
      <el-collapse>
        <el-collapse-item :title="$t('searchByConditions')" name="1">
          <el-form ref="storeform" :model="storeform">
            <el-form-item :label="$t('selectStore')">
              <template>
                <div class="" style="display: flex">
                  <el-select v-model="storeform.storeid" placeholder="" @change="changeTableStoreid">
                    <el-option :label="$t('all')" value="" v-if="storeid === null"></el-option>
                    <el-option v-for="item in storelist" :label="item.storeid + ' (' + item.name + ')'"
                      :value="item.storeid"></el-option>
                  </el-select>
                </div>
              </template>
            </el-form-item>
          </el-form>
          <div style="margin-bottom: 20px;">
            {{ $t("searchByDate") }}
            <el-date-picker v-model="starttime" type="date" :placeholder="$t('selectDate')">
            </el-date-picker> {{ $t("to") }}
            <el-date-picker v-model="endtime" type="date" :placeholder="$t('selectDate')">
            </el-date-picker>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 20px;">
            <span>{{ $t("orderid") }}</span>
            <el-input v-model="orderid" clearable style="flex: 1; margin-left: 10px;">
            </el-input>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 20px;">
            <span>{{ $t("paymentid") }}</span>
            <el-input v-model="paymentid" clearable style="flex: 1; margin-left: 10px;">
            </el-input>
          </div>
          <el-button @click="filter()">{{ $t('search') }}</el-button>
        </el-collapse-item>
      </el-collapse>
      <br />
    </template>

    <template v-if="order_read === '1'">
      <el-table :data="tableData" stripe style="width: 100%" @sort-change="sortChange">

        <el-table-column prop="addtime" :label="$t('time')" sortable="custom">
          <template slot-scope="scope">
            <div>{{ scope.row.addtime | formatDate }} </div>
          </template>
        </el-table-column>
        <el-table-column prop="storeid" :label="$t('storeid')" sortable="custom" width="">
        </el-table-column>
        <el-table-column prop="orderid" :label="$t('orderid')" sortable="custom">
        </el-table-column>
        <el-table-column prop="whatsapp" :label="$t('phoneNumber')" sortable="custom">
        </el-table-column>
        <el-table-column prop="nickname" :label="$t('nickname')" sortable="custom">
        </el-table-column>
        <el-table-column prop="total_price" :label="$t('totalAmount')" sortable="custom">
        </el-table-column>
        <el-table-column prop="status" :label="$t('status')" sortable="custom">
        </el-table-column>
        <el-table-column prop="paymentid" :label="$t('paymentid')" sortable="custom">
        </el-table-column>

        <el-table-column prop="operation" :label="$t('adminset')" align="center">
          <template slot-scope="scope">
            <div class="operationVid">
              <el-button @click="viewitem(scope.row)" v-if="order_edit === '1'">{{ $t('viewOrders') }}</el-button>
              <span v-if="order_edit === '0'">{{ $t("NoPermissions") }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination flex-center">
        <span class="el-pagination__total">{{ $t('total') }} {{ totalRecord }} {{ $t('items') }}</span>
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          layout="prev,pager,next" :total="totalRecord"></el-pagination>
      </div>
    </template>
    <template v-if="order_read === '0'">
        <span>{{ $t("NoPermissions") }}</span>
    </template>

    <!-- view -->
    <el-dialog :title="viewOrderTitle" :visible.sync="dialogVisible" :width="$store.state.isMobile ? '90%' : '556px'"
      :before-close="handleClose" class="view-dialog">
      <h4>{{ $t('status') }}: {{ viewOrderStatus }} </h4>
      <template v-if="viewOrderPayment !== null">
        <h4>{{ $t('paymentid') }}: {{ viewOrderPayment }}</h4>
      </template>
      <template v-if="viewOrderPaymentMethod.length > 0">
        <h4>{{ $t('paymentMethod') }}: {{ viewOrderPaymentMethod }}</h4>
      </template>
      <h4>{{ $t('totalAmount') }}: {{ viewOrderPaymentAmount }}</h4>
      <template v-if="viewOrderPickupAddress !== null">
        <h4>{{ $t('pickupAddress') }}: {{ viewOrderPickupAddress }}</h4>
      </template>
      <template v-if="viewOrderShippingAddress !== null">
        <h4>{{ $t('shippingAddress') }}: {{ viewOrderShippingAddress }}</h4>
      </template>
      <template v-if="viewOrderShippingPerson !== null">
        <h4>{{ $t('recipient') }}: {{ viewOrderShippingPerson }}</h4>
      </template>
      <template v-if="viewOrderShippingContact !== null">
        <h4>{{ $t('recipientNumber') }}: {{ viewOrderShippingContact }}</h4>
      </template>
      <el-table :data="viewData.products.slice((currentViewPage - 1) * pageViewSize, currentViewPage * pageViewSize)
        " stripe style="width: 100%">
        <el-table-column prop="goods_name" :label="$t('productName')">
        </el-table-column>

        <el-table-column prop="goods_number" :label="$t('quantity')">
        </el-table-column>

        <el-table-column prop="goods_price" :label="$t('price')">
        </el-table-column>

        <el-table-column prop="goods_price" :label="$t('totalAmount')">
          <template slot-scope="scope">
            <div>{{ (scope.row.goods_price * scope.row.goods_number).toFixed(2) }} </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination flex-center">
        <span class="el-pagination__total">{{ $t('total') }} {{ viewData.products.length }} {{ $t('items') }}</span>
        <el-pagination background @current-change="handleCurrentViewChange" :current-page="currentViewPage"
          :page-size="pageViewSize" layout="prev,pager,next" :total="viewData.products.length"></el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t("Cancel") }}</el-button>
        <el-button type="primary" @click="dialogVisible = false">{{
          $t("Sure")
        }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
// import { filter } from 'core-js/core/array';
import { formatDate } from '../../assets/date.js'
import { getShopOrder, getShopOrder_2, exportShopOrder_2, getStore } from '@/api'
export default {
  data() {
    return {
      order_read: '0',
			order_edit: '0',
			exportcsv: '0',
      show: false,
      currentPage: 1, // 当前页码
      pageSize: 15, // 每页显示的行数
      currentViewPage: 1, // 当前页码
      pageViewSize: 10, // 每页显示的行数
      dialogVisible: false,
      tableData: [

      ],
      tableDataExcel: [],
      tableDataExcelFields: {
        'add time': 'addtime',
        'store id': 'storeid',
        'order id': 'orderid',
        'name': 'name',
        'whatsapp': 'whatsapp',
        'products': 'products',
        'total amount': 'totalprice',
        'status': 'status',
        'payment id': 'paymentid',
        'payment method': 'paymentmethod',
        'shipping address': 'shippingaddress',
        'shipping person': 'shippingperson',
        'shipping contact': 'shippingcontact'
      },
      viewData: {
        id: "",
        products: []
      },
      starttime: "",
      endtime: "",
      orderid: "",
      paymentid: "",
      viewOrderTitle: "",
      viewOrderStatus: "",
      viewOrderPayment: "",
      viewOrderPaymentMethod: "",
      viewOrderPaymentAmount: "",
      viewOrderShippingAddress: "",
      viewOrderShippingPerson: "",
      viewOrderShippingContact: "",
      qyid: '',
      storeid: '',
      storelist: [],
      storeform: {
        storeid: ''
      },
    }
  },
  filters: {
    formatDate: function (time) {
      time = time * 1000     //注意：time应为格式为13位unix時間戳，如果是10位的unix時間戳，需要乘以1000
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  },
  created() {
    var user = JSON.parse(window.localStorage.getItem("userinfo"));
    //console.log(user)
    //this.qyid = user.id
    var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
		this.qyid = auser.qyid
        this.storeid = auser.storeid
        if(auser.storeid) {
            this.storeform.storeid = auser.storeid
        }
		this.order_read = auser.order_read
		this.order_edit = auser.order_edit
		this.exportcsv = auser.exportcsv
    this.getlist(auser.storeid);
    this.getstorelist()
  },
  methods: {
    handleCurrentViewChange(val) {
      this.currentViewPage = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getlist(this.storeform.storeid)
    },
    handleClose() {
      this.dialogVisible = false;
    },
    changeTableStoreid() {
      console.log('storeid:' + this.storeform.storeid)
      this.getlist(this.storeform.storeid)
    },
    filter() {
      this.getlist(this.storeform.storeid)
    },
    getstorelist() {
      console.log('go taocan');
      var user = JSON.parse(window.localStorage.getItem('userinfo'))

      let fdata = {
        qyid: this.qyid,
        storeid: this.storeid
      };
      getStore(fdata).then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.storelist = res.data
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    getlist(storeid) {
      this.show = true
      console.log("go list");
      var user = JSON.parse(window.localStorage.getItem("userinfo"));



      let fdata = {
        //qyid: user.id,
        qyid: this.qyid,
        storeid: storeid,
        starttime: this.starttime,
        endtime: this.endtime,
        orderid: this.orderid,
        paymentid: this.paymentid,
        record_page: this.currentPage,
        record_limit: 15,
      };

      getShopOrder_2(fdata).then(res => {
        if (res.code == 1) {
            this.tableData = res.data
            this.totalRecord = res.total;
        } else {
            console.log('eeeeeeeeeeeeeeeeeeeeee')
            this.$message({
                type: 'error',
                message: res.msg
            })
        }
      })


      /*
      getShopOrder(fdata).then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.tableData = res.data;
          this.tableDataExcel = res.dataExcel;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
        this.show = false
      });*/
    },
    viewitem(row) {
      var user = JSON.parse(window.localStorage.getItem("userinfo"));
      let fdata = {
        //qyid: user.id,
        qyid: this.qyid,
        id: row.id,
        orderid: row.orderid,
        action: "view"
      };
      //console.log('view: ' + id + " qyid: " + user.id)
      getShopOrder(fdata).then((res) => {
        if (res.code == 1) {
          console.log('shoporder');
          console.log(res);
          console.log(row);
          this.viewOrderTitle = `${this.$t('viewOrders')}: ${row.orderid}`;
          this.viewOrderStatus = row.status;
          this.viewOrderPayment = row.paymentid;
          this.viewOrderPaymentMethod = row.paymentmethod;
          this.viewOrderPaymentAmount = row.total_price;
          this.viewOrderPickupAddress = row.pickup_address;
          this.viewOrderShippingAddress = row.shipping_address;
          this.viewOrderShippingPerson = row.shipping_person;
          this.viewOrderShippingContact = row.shipping_contact;
          this.viewData.id = row.id;
          this.viewData.products = res.data;
          console.log('res.data')
          console.log(res.data)
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }



        this.dialogVisible = true;
      });
    },
    exporttocsv(name) {
        let fdata = {
            //qyid: user.id,
            qyid: this.qyid,
            storeid: this.storeform.storeid,
            starttime: this.starttime,
            endtime: this.endtime,
            orderid: this.orderid,
            paymentid: this.paymentid,
        };
        exportShopOrder_2(fdata).then(res => {
				if (res.code == 1) {
					console.log('getUsersReporttttttttttttttttttt')
					console.log(res)
					//this.tableData = res.data
                    //this.totalRecord = res.total;
					this.tableDataExcel = res.dataExcel
					var csvContent= [
                    Object.keys(this.tableDataExcel[0]).join(","),
                        ...this.tableDataExcel.map(item => Object.values(item).join(","))
                    ]
                        .join("\n")
                        .replace(/(^\[)|(\]$)/gm, "");
                    var link = document.createElement('a');
                    // "\ufeff"是为了解决CSV中文乱码问题
                    var blob = new Blob(["\ufeff" +csvContent],{type: 'text/csv;charset=utf-8;'});
                    var url = URL.createObjectURL(blob);
                    link.href = url;
                    link.setAttribute('download', name + '.csv');
                    link.click();
                    document.body.removeChild(link);
                        } else {
                            console.log('eeeeeeeeeeeeeeeeeeeeee')
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })

		},
    sortChange({ prop, order }) {
      this.tableData.sort(this.compare(prop, order));
    },
    compare(propertyName, sort) {
      return function (obj1, obj2) {
        var value1 = obj1[propertyName]
        var value2 = obj2[propertyName]
        if (typeof value1 === 'string' && typeof value2 === 'string') {
          const res = value1.localeCompare(value2, 'zh')
          return sort === 'ascending' ? res : -res
        } else {
          if (value1 <= value2) {
            return sort === 'ascending' ? -1 : 1
          } else if (value1 > value2) {
            return sort === 'ascending' ? 1 : -1
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.view-dialog {
  ::v-deep .el-dialog__body {
    padding: 10px 20px;
  }
}

.el-pagination__total {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  box-sizing: border-box;
}

.pendingList-wrapper {}

.pagination {
  width: 100%;
  margin: 30px auto;
}

::v-deep .el-select {
  width: 100%;
}
</style>